import PropTypes from 'prop-types'
import React from 'react'
import { Route, Redirect, useLocation } from 'react-router-dom'
import { useAuth } from './Auth'
import MigrateBranchOffice from '../organisms/branch_offices/MigrateBranchOffice'
import { isLoading, isSuccessful } from '../../hooks/useQuery'

const PrivateRoute = ({ children, ...rest }) => {
  const { status, user } = useAuth()
  const location = useLocation()

  if (isLoading(status)) return <Route {...rest}>{null}</Route>

  if (status === 'failed')
    return (
      <Route {...rest}>
        <Redirect to="/login" />
      </Route>
    )

  if (user?.institution_need_migration && user?.role === 'coordinator')
    return <MigrateBranchOffice institutionId={user?.institution_id} />

  if (isSuccessful(status)) {
    if (user?.needs_email_verification && location.pathname !== '/verificar-correo') {
      return <Route {...rest}><Redirect to="/verificar-correo" /></Route>
    }
    if (user?.needs_password_change && location.pathname !== '/cambiar-contrasena') {
      return <Route {...rest}><Redirect to="/cambiar-contrasena" /></Route>
    }
    return <Route {...rest}>{children}</Route>
  }

  return null
}

export default PrivateRoute

PrivateRoute.propTypes = {
  children: PropTypes.node
}
